import { render } from "./dictionaryComponent.vue?vue&type=template&id=0c02712e"
import script from "./dictionaryComponent.vue?vue&type=script&lang=js"
export * from "./dictionaryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__